import { render } from "@/share/components/controls/paginationTable/PaginationImgTable.html?vue&type=template&id=9662cbbc&scoped=true&external"
import script from "@/share/components/controls/paginationTable/PaginationImgTable.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/paginationTable/PaginationImgTable.js?vue&type=script&lang=js&external"

import "@/share/components/controls/paginationTable/PaginationImgTable.scss?vue&type=style&index=0&id=9662cbbc&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9662cbbc"]])

export default __exports__